import { Link } from "react-router-dom";
import { LayoutGrid, LogOut, Package, ShoppingBag, User } from "lucide-react";

const TABS = [
  { key: "overview", label: "Overview", icon: LayoutGrid },
  { key: "orders", label: "Orders", icon: Package },
  { key: "profile", label: "Profile", icon: User },
];

export const AccountNav = ({ active, onChange, onLogout, customer }) => {
  const initials =
    `${customer.first_name?.[0] || ""}${customer.last_name?.[0] || ""}`.toUpperCase() ||
    (customer.email?.[0] || "?").toUpperCase();

  return (
    <aside className="lg:sticky lg:top-28" data-testid="account-nav">
      <div className="flex items-center gap-3 rounded-2xl bg-neutral-900 p-4 text-white">
        <div className="grid h-11 w-11 shrink-0 place-items-center rounded-full bg-white/10 font-heading text-sm font-bold">
          {initials}
        </div>
        <div className="min-w-0">
          <p className="truncate font-heading text-sm font-bold" data-testid="account-nav-name">
            {[customer.first_name, customer.last_name].filter(Boolean).join(" ") || "Welcome"}
          </p>
          <p className="truncate text-xs text-white/60" data-testid="account-nav-email">
            {customer.email}
          </p>
        </div>
      </div>

      <nav className="mt-3 flex gap-1 overflow-x-auto rounded-2xl border border-neutral-200 bg-white p-1.5 lg:flex-col lg:overflow-visible">
        {TABS.map(({ key, label, icon: Icon }) => (
          <button
            key={key}
            type="button"
            data-testid={`account-tab-${key}`}
            onClick={() => onChange(key)}
            className={`flex shrink-0 items-center gap-2.5 rounded-xl px-4 py-2.5 text-sm font-semibold transition-colors ${
              active === key ? "bg-neutral-900 text-white" : "text-neutral-600 hover:bg-neutral-100"
            }`}
          >
            <Icon size={15} /> {label}
          </button>
        ))}
        <Link
          to="/shop"
          data-testid="account-continue-shopping"
          className="flex shrink-0 items-center gap-2.5 rounded-xl px-4 py-2.5 text-sm font-semibold text-neutral-600 transition-colors hover:bg-neutral-100"
        >
          <ShoppingBag size={15} /> Continue Shopping
        </Link>
        <button
          type="button"
          data-testid="account-logout-button"
          onClick={onLogout}
          className="flex shrink-0 items-center gap-2.5 rounded-xl px-4 py-2.5 text-sm font-semibold text-neutral-600 transition-colors hover:bg-rose-50 hover:text-rose-700"
        >
          <LogOut size={15} /> Log Out
        </button>
      </nav>
    </aside>
  );
};
